module.exports = __webpack_public_path__ + "img/landing-btn-facebook-icon.282f56c1.svg";